import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { MiniProductReviews } from '@bepure/tarkin';

declare const BASE_API_URL: string;

interface Review {
    score: number;
    title: string;
    description?: string;
    firstName?: string;
    lastName?: string;
    createdAt: Date;
    companyResponse?: string;
}

interface Props {
    reviews: {
        [id: number]: Review,
    };
    noText?: boolean;
    hyperlink?: string;
    orange?: boolean;
}

class MiniProductReviewsSection extends React.PureComponent<Props> {

    public render() {
        const numReviews = Object.keys(this.props.reviews).length;
        let totalScore = 0;
        if (numReviews !== 0) {
            totalScore = Object.keys(this.props.reviews).map((key, index) => {
                return this.props.reviews[key].score;
            }).reduce((total, currentScore) => {
                return total + currentScore;
            });
        }

        return (
            <MiniProductReviews
                numReviews={numReviews}
                averageScore={totalScore / numReviews}
                noText={this.props.noText}
                hyperlink={this.props.hyperlink}
                orange={this.props.orange}
            />
        );
    }
}

interface ReviewResponse {
    reviews: {
        [id: number]: {
            description?: string;
            email?: string;
            firstName?: string;
            lastName?: string;
            productId?: number;
            score: number;
            title: string;
            createdAt: Date;
        },
    };
}

const getReviews = async (productSku: string): Promise<ReviewResponse | null> => {
    const response = await fetch(`${BASE_API_URL}/v1/product/reviews/${productSku}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
    });
    try {
        return await response.json();
    } catch  (error) {
        throw Promise.reject(null);
    }
};

export default function render() {
    const elements = document.getElementsByClassName('mini-obiwan-product-reviews');
    Array.prototype.map.call(elements, (element: HTMLElement) => {
        const productSku = element.dataset.productSku || '';
        const noText = element.dataset.noText === 'true';
        const hyperlink = element.dataset.hyperlink || undefined;
        const orange = element.dataset.orange === 'true';
        getReviews(productSku).then((r) => {
            const reviews: {
                [id: number]: Review,
            } = r ? r.reviews : {};
            if (reviews) {
                return ReactDOM.render(
                    <MiniProductReviewsSection
                        reviews={reviews}
                        noText={noText}
                        hyperlink={hyperlink}
                        orange={orange}
                    />,
                    element,
                );
            }
        }).catch((r) => {
            // tslint:disable-next-line: no-console
            console.log('Mini Product Reviews render failed', r);
        });
    });
}
